// Hooks
import React, {useEffect, useState} from "react";

// Components
import Link from "next/link";

// Utils & Libs
import PriceFormatter from "@/utils/PriceFormatter";

// Assets

// Types
import {IProduct} from "@/types/product.types";

const ProductCard: React.FC<{data: IProduct}> = ({data}) => {
  const cheapest_variant = data?.variant_combinations?.sort((a, b) => +a.price - +b.price)[0];
  const is_product_has_price_range = +data?.price_max > +data?.price_min;
  const slug = `/product/${data?.categories[0]?.slug}/${data?.slug}`;

  const [isDiscount, setIsDiscount] = useState(false);
  const [price, setPrice] = useState({price: 0, promo: 0});

  useEffect(() => {
    // set price non variant product
    if (!data.variant_combinations?.length && +data.price_promo > 0 && +data.price_promo < +data.price) {
      setPrice({price: +data.price, promo: +data.price_promo});
      setIsDiscount(true);
    }

    if (cheapest_variant) {
      if (+cheapest_variant.price_promo > 0 && +cheapest_variant.price_promo < +cheapest_variant.price) {
        setPrice({price: +cheapest_variant.price, promo: +cheapest_variant.price_promo});
        setIsDiscount(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="group">
      {/* images */}
      <Link href={slug} className="relative flex items-center justify-center aspect-[1/1.35] bg-cream-base">
        {/* sold out */}
        {+data.qty < 1 ? (
          <div className="absolute top-0 flex items-center justify-center w-full h-full select-none bg-black/20">
            <span className="text-base font-semibold text-white uppercase">SOLD OUT</span>
          </div>
        ) : null}

        {/* discount */}
        {price.promo < price.price ? (
          <div className="absolute flex items-center justify-center select-none h-7 w-14 bg-red-base top-3 left-3">
            <span className="text-xs font-semibold text-white">SALE</span>
          </div>
        ) : null}

        {/* acutal product image */}
        {data?.categories?.length ? (
          <img
            className="object-contain w-full h-full cursor-pointer select-none aspect-square"
            src={data?.images[0]?.url || "/images/default-img.png"}
            alt={data?.name || "/images/default-img.png"}
          />
        ) : null}
      </Link>

      {/* info */}
      <div className="">
        {data.categories?.length ? (
          <>
            <span className="block mt-4 text-xs uppercase text-gray-base">
              {data.tags.map((data) => data.name).join(" , ")}
            </span>
            <Link
              href={`/product/${data?.categories[0]?.slug}/${data?.slug}`}
              className="mt-1 font-medium line-clamp-2 group-hover:underline"
            >
              {data?.name}
            </Link>
          </>
        ) : null}

        {/* price */}
        <div className="flex items-center mt-2 space-x-1">
          {/* no price range, no discount */}
          {!isDiscount && !is_product_has_price_range ? (
            <span className="font-bold">{PriceFormatter(+data?.price)}</span>
          ) : null}

          {/* price range , rules product dont have promo */}
          {!isDiscount && is_product_has_price_range ? (
            <div>
              <span className="font-bold">{PriceFormatter(+data.price_min)}</span>
              <span> - </span>
              <span className="font-bold">{PriceFormatter(+data.price_max)}</span>
            </div>
          ) : null}

          {/* price promo */}
          {isDiscount && price.promo < price.price ? (
            <div className="flex items-center gap-2">
              <span className="font-bold text-red-base">{PriceFormatter(price.promo)}</span>
              <span className="text-xs font-bold line-through text-gray-base">{PriceFormatter(price.price)}</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
